define(function(require, exports, module) {
    'use strict';
    var BetLimitsConfig = require('modules/bet-limits-config/bet.limits.config');

    module.exports = new BetLimitsConfig();
});
